var React = require('react');

function NumberOneInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.5001 22.782C6.90002 22.782 2.34387 18.2259 2.34387 12.6258C2.34387 7.02569 6.90002 2.46954 12.5001 2.46954C18.1002 2.46954 22.6564 7.02569 22.6564 12.6258C22.6564 18.2259 18.1002 22.782 12.5001 22.782Z","fill":"#FA7360","key":0}),React.createElement("path",{"d":"M13.6829 7.81818H11.9279L9.39737 9.44389V11.1342L11.7788 9.61293H11.8384V18H13.6829V7.81818Z","fill":"white","key":1})]);
}

NumberOneInline.defaultProps = {"viewBox":"0 0 25 26","fill":"none"};

module.exports = NumberOneInline;

NumberOneInline.default = NumberOneInline;
